<div class="section-header">
  <span class="section-title">{{ title }}</span>
  <span class="work-order-number">{{ workOrderNumber }}</span>
</div>
